import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";
import { Questionnaire } from "src/graphql/generated/graphql";

import { Section } from "../section";
import { AssignmentQuestionnaireDetail } from "./detail";

export interface AssignmentQuestionnaireProps {
    questionnaire: Questionnaire;
}

export const AssignmentQuestionnaire = ({ questionnaire }: AssignmentQuestionnaireProps) => {
    const { t } = useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section
            title={t("campaign_questionnaire")}
            isCollapsed={isCollapsed}
            onClick={toggleCollapse}
        >
            <AssignmentQuestionnaireDetail
                questionnaire={questionnaire}
            />
        </Section>
    );
};
